import { action, observable, toJS } from 'mobx';
import { pull } from 'lodash';
import Validator from 'validatorjs';
import lang from 'validatorjs/src/lang';
import en from 'validatorjs/src/lang/en';
import { capitalize } from 'shared/lib/helpers';

// eslint-disable-next-line
lang._set('en', en);

class BaseForm {
  @observable isValid = false;
  @observable pristine = true;
  @observable error = null;
  @observable saveInProgess = false;
  saveButtonUsesPristine = false;

  getFlattenedValues = (valueKey = 'value') => {
    const data = {};
    const form = toJS(this.fields);
    Object.keys(form).map((key) => {
      data[key] = form[key][valueKey];
    });
    return data;
  };

  @action
  onFieldChange = (e) => {
    this.pristine = false;
    let field = e.target.id;
    // Select has name, not id
    if (typeof field === 'undefined') {
      field = e.target.name;
    }
    const { value } = e.target;
    if (e.is_array) {
      if (!this.fields[field].value.includes(value)) {
        this.fields[field].value.push(value);
      } else {
        pull(this.fields[field].value, value);
      }
    } else if (e.is_checkbox) {
      this.fields[field].value = !this.fields[field].value;
    } else {
      this.fields[field].value = value;
    }
    const validation = new Validator(
      this.getFlattenedValues('value'),
      this.getFlattenedValues('rule')
    );
    this.isValid = validation.passes();
    const errorMessage = validation.errors.first(field);
    if (errorMessage) {
      this.fields[field].error = capitalize(errorMessage.replace(`The ${field.replace(/_/g, ' ')} `, '')); // this.fields[field].label);
    } else {
      this.fields[field].error = '';
    }
    // update error status of corresponding fields
    if (Array.isArray(this.fields[field].validateWith)) {
      this.fields[field].validateWith.forEach((nextField) => {
        const nextErrorMessage = validation.errors.first(nextField);
        if (nextErrorMessage) {
          this.fields[nextField].error = nextErrorMessage.replace(nextField, this.fields[nextField].label);
          this.fields[nextField].error = this.fields[nextField].error.replace(field, this.fields[field].label);
        } else {
          this.fields[nextField].error = '';
        }
        this.fields[field].error = this.fields[field].error.replace(nextField, this.fields[nextField].label);
      });
    }
  };

  @action
  setError = (errMsg) => {
    this.error = errMsg;
  }

  // allows to overwrite a form value from anywhere
  @action setProperty = (property, value) => {
    this.fields[property].value = value;
  }

  // can be used to save a global error, e.g. from a server
  @observable responseError = '';

  @action setResponseError = (error) => {
    this.responseError = error;
  }

  resetResponseError = () => {
    this.setResponseError('');
  }
}

export default BaseForm;
